import { CreditCardData } from "../Types/CreditCardDataType";
import { PaymentTokenResult } from "../Types/PaymentTokenType";
import EfiPay from "payment-token-efi";

const isProd = process.env.NODE_ENV === 'production';

// CRA exposes env vars with REACT_APP_*
const account = process.env.REACT_APP_EFI_ACCOUNT;

const environment = isProd ? 'production' : 'sandbox';

// export async function checkScriptBlocking() {
//   const isBlocked = await EfiPay.CreditCard.isScriptBlocked();
//   return isBlocked;
// }

export async function identifyBrand(
  cardNumber: string
): Promise<string | null> {
  try {
    const brand = await EfiPay.CreditCard
      .setCardNumber(cardNumber)
      .verifyCardBrand();
    return brand;
  } catch (error) {
    return null;
  }
};

export async function listInstallments(
  brand: string, 
  total: number
): Promise<EfiPay.CreditCard.InstallmentsResponse | null> {
  try {
    const response = await EfiPay.CreditCard
    .setAccount(account!)
    .setEnvironment(environment)
    .setBrand(brand)
    .setTotal(total) // Valor em centavos
    .getInstallments();

    if ("code" in response) {
      return null;
    }

    return response as EfiPay.CreditCard.InstallmentsResponse;
  } catch (error) {
    return null;
  }
};

export async function generatePaymentToken(
  creditCardData: CreditCardData
): Promise<PaymentTokenResult | null> {
  if (!creditCardData.cardBrand || !creditCardData.cardNumber) {
    return null;
  }

  try {
    const result = await EfiPay.CreditCard
      .setAccount(account!)
      .setEnvironment(environment)
      .setCreditCardData({
        brand: creditCardData.cardBrand,
        number: creditCardData.cardNumber.replace(/\s/g, ""),
        cvv: creditCardData.cardCvv,
        expirationMonth: creditCardData.cardExpiration.slice(0, 2),
        expirationYear: (() => {
          const yearPart = creditCardData.cardExpiration.slice(3).replace(/\D/g, "");
          return yearPart.length === 4 ? yearPart : `20${yearPart}`;
        })(),
        holderName: creditCardData.cardName,
        holderDocument: creditCardData.holderDocument.replace(/\D/g, ""),
        reuse: false
      })
      .getPaymentToken();

    if ("payment_token" in result && "card_mask" in result) {
      return {
        paymentToken: result.payment_token,
        cardMask: result.card_mask
      }
    }

    return null;
  } catch (error) {
    return null;
  }
};
